<template>
  <the-login v-if="!isLoggedIn" @cargado="readyToMap" :login-message="loginMessage"></the-login>
  <!-- <the-table></the-table> -->
  <div v-if="isLoggedIn">
    <div class="btn rounded-circle position-fixed btn-menu" @click="toggleMenu">
      <i :class="menuOpen ? 'bi bi-x-lg' : 'bi bi-list'"></i>
    </div>
    <the-side-bar @item-selected="viewSelected" @restore-modal="restoreModal"
      :class="['sidebar-wrapper', { 'sidebar-hidden': !menuOpen }]" :minimized-modals="minimizedModals"></the-side-bar>
    <div v-if="isMobile && !isEmbeddedInMobileApp" class="btn rounded-circle position-fixed btn-new-event" @click="crearEventoMobile">
      <i class="bi bi-geo-alt"></i>
    </div>

    <the-main-map v-if="isMap" ref="mainMapRef" @event-selected="viewEventDetails" :mapa="map" @crear-evento="crearEvento"
      :center="mapCenter" @map-click="handleMapClick" @update-center="updateMapCenter"></the-main-map>

    
    <new-event-selector v-if="newEvent" @close="closeNewEvent" @button-selected="formNewEvent"
      :new-event-data="newEventData"></new-event-selector>
    <new-event-form v-if="isNewEventForm" @close="cancelFormNewEvent" :new-event-data="newEventData" @center-map="centerMap"></new-event-form>
    <event-details v-if="isEventDetails" @closed="closeEventDetails" 
    @edit="editEvent"
    :selected-event="SelectedEvent"></event-details>
    <edit-event-form   :event-data="SelectedEvent"  @close="closeEditEvent" v-if="isEditEventForm"></edit-event-form>
    
    <the-layers v-if="isLayers" @closed="viewLayers"></the-layers>

    <the-events v-if="isEvents" ref="eventsModalRef" @closed="viewEvents" @row-selected="centerMap"
      @minimize="handleModalMinimize" @restore="handleModalRestore"></the-events>
    <image-library v-if="isImageLibrary" ref="imageLibraryRef" @closed="viewImages" @image-selected="centerMap"
      @minimize="handleModalMinimize" @restore="handleModalRestore"></image-library>
    <mosaic-library v-if="isMosaicLibrary" ref="mosaicLibraryRef" @closed="viewMosaics" @mosaic-selected="centerMap"
      @minimize="handleModalMinimize" @restore="handleModalRestore"></mosaic-library>
    <video-library v-if="isVideoLibrary" ref="videoLibraryRef" @closed="viewVideos" @video-selected="centerMap"
      @minimize="handleModalMinimize" @restore="handleModalRestore"></video-library>
    <media-library-tabs v-if="isSearchModule" ref="mediaLibraryRef" :is-visible="isSearchModule" 
      @video-selected="centerMap" @image-selected="centerMap"
      @minimize="handleModalMinimize" @restore="handleModalRestore"></media-library-tabs>


    <orders-library v-if="isOrdersLibrary" ref="ordersLibraryRef" @closed="viewOrders" @minimize="handleModalMinimize" 
     :viewReport="selectedRmReport"
      @restore="handleModalRestore" @goto-related="gotoRelatedReport('RM',  $event)"></orders-library>
    <reports-library v-if="isReportsLibrary" ref="reportsLibraryRef" @closed="viewReports" :viewReport="selectedRmReport"
      @minimize="handleModalMinimize" @restore="handleModalRestore" @goto-related="gotoRelatedReport('OM',  $event)"></reports-library>
    <mission-plans v-if="isMissionPlan" ref="missionPlansRef" @closed="viewMissions" @minimize="handleModalMinimize"
      @restore="handleModalRestore"></mission-plans>

    <video-live v-if="isVideoLive" @closed="viewLive" :unit_id="videoLiveUnitId"></video-live>
    <new-event-mobile v-if="isNewEventMobile" :new-event-data="newEventData" @close="isNewEventMobile = false"></new-event-mobile>
  <bottom-bar :center="mapCenter" @showVideoLive="viewLive" @unit-selected="centerMap"></bottom-bar>
  </div>
</template>

<script setup lang="ts">

function updateMapCenter(newCenter: [number, number]) {
  mapCenter.value = [...newCenter] as CoordenadasCenter
}
import { ref, onMounted, reactive, watch } from 'vue'
import { useGeolocation } from '@/composables/useGeolocation'
import type { Evento, CoordenadasCenter, NewEventData, ReportFile } from './types'
import { useServicesStore } from './stores/services'  
import { useGlobalStore } from './stores/global'
import { useAuthStore } from './stores/t-auth'
import { storeToRefs } from 'pinia'
import { useUtils } from '@/composables/useUtils';

// Component imports
import TheMainMap from './components/TheMainMap.vue'
import TheLogin from './components/TheLogin.vue'
import TheEvents from './components/TheEvents.vue'
import TheSideBar from './components/TheSideBar.vue'
import TheLayers from './components/TheLayers.vue'

import BottomBar from './components/BottomBar.vue'
import VideoLibrary from './components/VideoLibrary.vue'
import MosaicLibrary from './components/MosaicLibrary.vue'
import NewEventSelector from './components/NewEventSelector.vue'
import NewEventForm from './components/NewEventForm.vue'
import EventDetails from './components/EventDetails.vue'
import EditEventForm from './components/EditEventForm.vue'
import ImageLibrary from './components/ImageLibrary.vue'
import VideoLive from './components/VideoLive.vue'
import ReportsLibrary from './components/ReportsLibrary.vue'
import OrdersLibrary from './components/OrdersLibrary.vue'
import MissionPlans from './components/MissionPlans.vue'
import NewEventMobile from './components/NewEventMobile.vue'
import MediaLibraryTabs from './components/MediaLibraryTabs.vue'
import API from './services'
const { isMobileDevice } = useUtils();

// Geolocalización para dispositivos móviles
const {
  position: geoPosition,
  error: geoError,
  acquiring: geoAcquiring,
  getCurrentPosition
} = useGeolocation({ immediate: false });

const auth = useAuthStore()
const serv = useServicesStore()
const global = useGlobalStore()
const { isEvents, isImageLibrary, isVideoLibrary, isMissionPlan, isOrdersLibrary, isMobile, isMosaicLibrary, isSearchModule, isEmbeddedInMobileApp } = storeToRefs(global)




const isLoggedIn = ref(false)
const loginMessage = ref('');



// Solo poner isLoggedIn en false si auth.logedUser es vacío
watch(() => auth.logedUser, (val) => {
  if (val === 'error') {
    isLoggedIn.value = false;
    loginMessage.value = 'Debe logearse para continuar. Revise que no haya otro dispositivo logeado con su cuenta en el sistema.';
  } 
}, { immediate: true })

const mapCenter = ref<CoordenadasCenter>([-38.03309, -72.75332])
const isMap = ref(false)

const isLayers = ref(false)
const isEventDetails = ref(false)
const isVideoLive = ref(false)
const videoLiveUnitId = ref<string | null>(null)
const isReportsLibrary = ref(false)
const map = ref('OpenStreetMap')
const mainMapRef = ref<InstanceType<typeof TheMainMap> | null>(null)
const newEvent = ref(false)
const isNewEventForm = ref(false)
const isEditEventForm = ref(false)
const menuOpen = ref(false)

const isNewEventMobile = ref(false)

const newEventData = reactive<NewEventData>({ event_type_id: 0, lat: 0, lon: 0 })

const newLat = ref(0)
const newLon = ref(0)

onMounted(async () => {
  // Auto-login desde alerce-mobile via postMessage
  window.addEventListener('message', async (event: MessageEvent) => {
    if (event.data?.type !== 'ALERCE_MOBILE_AUTH') return;
    if (isLoggedIn.value) return; // ya logueado, ignorar

    const { token: accessToken, refreshToken: refreshTokenVal, user } = event.data;
    if (!accessToken || !user) return;

    const ok = await auth.setSession(accessToken, refreshTokenVal ?? '', user);
    if (ok) {
      isEmbeddedInMobileApp.value = true;
      await readyToMap();
    }
  });
})

async function readyToMap() {
  console.log('ready to map')
  isMobile.value = isMobileDevice();
  serv.dispatchGetEventTypes()
  loadEventosPropios()
  //serv.dispatchListPredios()
  isLoggedIn.value = true
  isMap.value = true
  isSearchModule.value = await API.checkPermiso("SEARCH_MODULE")
  // Si es mobile, centrar mapa en la ubicación del dispositivo si es posible
  if (isMobile.value) {
    try {
      await getCurrentPosition();
      if (geoPosition.value && geoPosition.value.coords) {
        const { latitude, longitude } = geoPosition.value.coords;
        centerMap([longitude, latitude]);
      }
    } catch (e) {
      // Si falla, no cambia el centro
    }
  }
}
function loadEventosPropios() {
  // Fecha y hora actual en UTC
  const now = new Date();
  // Fecha 24 horas atrás en UTC
  const start = new Date(now.getTime() - 24 * 60 * 60 * 1000);

  // Formato YYYYMMDD para start_date (UTC)
  const startDate = start.getUTCFullYear().toString() +
    String(start.getUTCMonth() + 1).padStart(2, '0') +
    String(start.getUTCDate()).padStart(2, '0');

  // Formato YYYYMMDDHH24MMSS para end_date (UTC)
  const endDate = now.getUTCFullYear().toString() +
    String(now.getUTCMonth() + 1).padStart(2, '0') +
    String(now.getUTCDate()).padStart(2, '0') +
    String(now.getUTCHours()).padStart(2, '0') +
    String(now.getUTCMinutes()).padStart(2, '0') +
    String(now.getUTCSeconds()).padStart(2, '0');

  const userId = auth.logedUser || '0'; // Asegurarse de tener un userId válido
  serv.dispatchGetEventsPropios(startDate, endDate, userId);
}

function viewSelected(selected: string) {
  switch (selected) {
    case 'layers': {
      viewLayers()
      break
    }
    case 'events': {
      viewEvents()
      break
    }
    case 'mapa': {
      changeMap()
      break
    }
    case 'images': {
      viewImages()
      break
    }
    case 'mosaics': {
      viewMosaics()
      break
    }
    case 'videos': {
      viewVideos()
      break
    }
    case 'reports': {
      viewReports()
      break
    }
    case 'missions': {
      viewMissions()
      break
    }
    case 'orders': {
      viewOrders()
      break
    }
  }
}

function toggleMenu() {
  menuOpen.value = !menuOpen.value
}

function viewLive(unit_id?: string) {
  videoLiveUnitId.value = unit_id ?? null
  isVideoLive.value = !isVideoLive.value
}
function viewLayers() {
  isLayers.value = !isLayers.value
}
function viewEvents() {
  isEvents.value = !isEvents.value
  //isMap.value = !isMap.value
  /*   if (isEvents.value) {
      openNewWindow()
    } */
}
function viewImages() {
  isImageLibrary.value = !isImageLibrary.value
}
function viewMosaics() {
  isMosaicLibrary.value = !isMosaicLibrary.value
}
function viewVideos() {
  isVideoLibrary.value = !isVideoLibrary.value
}
function viewReports() {
  isReportsLibrary.value = !isReportsLibrary.value
}
function viewMissions() {
  isMissionPlan.value = !isMissionPlan.value
}
function viewOrders() {
  isOrdersLibrary.value = !isOrdersLibrary.value
}
function viewMediaLibrary() {
  isSearchModule.value = !isSearchModule.value
}
const SelectedEvent = ref<Evento>({
  event_id: 0,
  record_number: 0,
  record_unit: '',
  utc: '',
  event_number: 0,
  event_unit: '',
  type: '',
  description: '',
  mission: 0,
  reference: 0,
  location: {
    type: '',
    coordinates: [0, 0]
  },
  state: '',
  scope: '',
  user_visible: 0,
  user_id: '0',
  data: '',
  json: ''
})

function viewEventDetails(selectedEvent: Evento) {
  console.log(selectedEvent)
  SelectedEvent.value = selectedEvent
  isEventDetails.value = true
}

function closeEventDetails() {
  isEventDetails.value = false
}
async function crearEventoMobile() {
  // Solo intentar obtener coordenadas si es móvil
  if (isMobile.value) {
    try {
      await getCurrentPosition();
      if (geoPosition.value && geoPosition.value.coords) {
        const { latitude, longitude } = geoPosition.value.coords;
        crearEvento([latitude, longitude]);
        return;
      } else {
        // Si no se pudo obtener, fallback a centro del mapa
        crearEvento(mapCenter.value);
      }
    } catch (e) {
      // Si hay error, fallback a centro del mapa
      crearEvento(mapCenter.value);
    }
  } else {
    crearEvento(mapCenter.value);
  }
}
function crearEvento(coordenadas: [number, number]) {
  newEventData.event_type_id = 0
  newEventData.lat = coordenadas[0]
  newEventData.lon = coordenadas[1]
  newEvent.value = true
}
function formNewEvent(datos: NewEventData) {
  newEventData.event_type_id = datos.event_type_id
  newEvent.value = false
  isNewEventForm.value = true
}
function editEvent() {
  isEventDetails.value = false
  isEditEventForm.value = true
}
function closeEditEvent() {
  isEditEventForm.value = false
}
function cancelFormNewEvent() {
  isNewEventForm.value = false
}
function closeNewEvent() {
  newEvent.value = false
}
function changeMap() {
  if (map.value == 'OpenStreetMap') {
    map.value = 'Satelite'
  } else {
    map.value = 'OpenStreetMap'
  }
}
function centerMap(coordenadas: number[]) {
  if (coordenadas.length === 2) {
    mapCenter.value = [coordenadas[1], coordenadas[0]] as CoordenadasCenter
    
    // Si isSearchModule está activo, aplicar desplazamiento después de un breve delay
    // para que el mapa tenga tiempo de centrarse
    if (isSearchModule.value && mainMapRef.value?.map?.leafletObject) {
      setTimeout(() => {
        const leafletMap = mainMapRef.value?.map?.leafletObject
        if (leafletMap) {
          const mapSize = leafletMap.getSize()
          // Desplazar 25% del ancho hacia la derecha (para que el punto quede en el primer cuarto)
          const offsetX = mapSize.x * 0.25
          leafletMap.panBy([offsetX, 0], { animate: true, duration: 0.5 })
        }
      }, 100)
    }
  } else {
    console.error('Invalid coordinates received:', coordenadas)
  }
}
const minimizedModals = ref<string[]>([])

function handleModalMinimize(modalId: string) {
  if (!minimizedModals.value.includes(modalId)) {
    minimizedModals.value.push(modalId)
  }
}

function handleModalRestore(modalId: string) {
  minimizedModals.value = minimizedModals.value.filter((id) => id !== modalId)
}

function handleMapClick(coordenadas: [number, number]) {
  console.log('Click en mapa detectado en App:', coordenadas)

  // Si NewEventSelector está visible, cerrarlo
  if (newEvent.value) {
    console.log('Cerrando NewEventSelector debido a click en mapa')
    closeNewEvent()
  }
}
const eventsModalRef = ref()
const imageLibraryRef = ref()
const videoLibraryRef = ref()
const reportsLibraryRef = ref()
const missionPlansRef = ref()
const mediaLibraryRef = ref()
const selectedOmReport = ref<ReportFile | null>(null)
const selectedRmReport = ref<ReportFile | null>(null)

function restoreModal(modalId: string) {
  handleModalRestore(modalId)

  // Restaura el modal específico llamando a su método restore
  switch (modalId) {
    case 'events':
      eventsModalRef.value?.restoreModal()
      break
    case 'images':
      imageLibraryRef.value?.restoreModal()
      break
    case 'videos':
      videoLibraryRef.value?.restoreModal()
      break
    case 'reports':
      reportsLibraryRef.value?.restoreModal()
      break
    case 'missions':
      missionPlansRef.value?.restoreModal()
      break
    case 'media-library-tabs':
      mediaLibraryRef.value?.restoreModal()
      break
  }
}
function gotoRelatedReport(reportType: string, report: ReportFile) {

  if (reportType === 'RM') {
    selectedRmReport.value = report  
    isReportsLibrary.value = true
  } else if (reportType === 'OM') {
    selectedOmReport.value = report
    isOrdersLibrary.value = true
  }
}
</script>

<style>
.leaflet-bottom.leaflet-right .leaflet-control-attribution {
  right: auto !important;
  left: 0 !important;
  margin-left: 10px !important;
  margin-right: 0 !important;
  bottom: 43px !important;
  z-index: 1001;
}

.leaflet-bottom.leaflet-right {
  right: auto !important;
  left: 0 !important;
}

@media (max-width: 576px) {
  .leaflet-bottom.leaflet-right .leaflet-control-attribution {
    bottom: 0px !important;
  }
}

.btn-menu {
  top: 60px;
  left: 10px;
  background-color: #00000099 !important;
  backdrop-filter: blur(5px);
  color: #ffffff !important;
  z-index: 1000;
  transition: left 0.3s ease-in-out;
}
.btn-new-event {
  top: 500px;
  left: 10px;
  background-color: #249a35a7 !important;
  backdrop-filter: blur(5px);
  color: #ffffff !important;
  z-index: 1000;
  transition: left 0.3s ease-in-out;
}
/* Solo agrega la transición sin cambiar las dimensiones existentes */
.sidebar-wrapper {
  transition: transform 0.3s ease-in-out;
}

.sidebar-wrapper.sidebar-hidden {
  transform: translateX(-100%);
}

/* Opcional: mover el botón cuando el sidebar esté abierto */
.sidebar-wrapper:not(.sidebar-hidden)~.btn-menu {
  left: 260px;
}
</style>
